import React from 'react';
import { useState } from 'react';
import { ApproachTabsContent } from '../../Data/ApproachTabsContent';

function TabsSection(props) {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="tabs">
                        <div className="text-list tabs-list text-list-large">
                            <h4 className={`heading tab-heading heading-small ${props.dark ? 'light-2' : 'dark-2'}`}>
                                SERVICES
                            </h4>

                            <div className="nav-pills-wrapper">
                                <ul className={`nav nav-pills ${props.dark ? 'light-1' : 'dark-1'}`} role="tablist">
                                    {ApproachTabsContent.map((item, index) => {
                                        const tabId = `services-tab-${index}`;
                                        const panelId = `services-panel-${index}`;

                                        return (
                                            <li key={index}>
                                                <button
                                                    type="button"
                                                    className={`nav-link${activeTab === index ? ' active' : ''}`}
                                                    id={tabId}
                                                    role="tab"
                                                    aria-selected={activeTab === index}
                                                    aria-controls={panelId}
                                                    onClick={() => setActiveTab(index)}
                                                >
                                                    <span>{item.name}</span>
                                                </button>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                        <div className="tabs-content tab-content">
                            {ApproachTabsContent.map((item, index) => {
                                const tabId = `services-tab-${index}`;
                                const panelId = `services-panel-${index}`;

                                if (activeTab !== index) {
                                    return null;
                                }

                                return (
                                    <div
                                        key={panelId}
                                        id={panelId}
                                        className="tab-single show active tab-pane fade"
                                        role="tabpanel"
                                        aria-labelledby={tabId}
                                    >
                                        <h4 className={`heading heading-small ${props.dark ? 'light-2' : 'dark-2'}`}>
                                            {item.name}
                                        </h4>
                                        <div className={`paragraph ${props.dark ? 'light-1' : 'dark-1'}`}>
                                            {item.content}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TabsSection;
